module.exports = __webpack_public_path__ + "static/velo-ba99b26eaa81f47c8686edbe9395ed57.jpg";